import { select } from '@frameio/i18n';
import { DotSeparator } from '@frameio/shared/components/DotSeparator';
import { Text, theme } from '@frameio/vapor';
import { IconArrowDown, IconArrowUp } from '@frameio/vapor-icons';
import type { TransferBatch } from '../../../types/uploader';
import { getProgressType } from '../../../utils';
import { ARROW_ICON_CLASSNAME } from '../constants';
import { JobSize } from '../JobSize';
import { ScrollingJob } from '../ScrollingJob';
import TEXT from './generated/TEXT/QueuedJobStatus';

TEXT.DEFINE(
  {
    /** Status label when transfer is queued, varies by transfer type */
    queuedStatus: (progressType: string): string =>
      select(progressType, {
        DOWNLOAD: 'Download queued',
        RENDER: 'Export queued',
        other: 'Upload queued',
      }),
    /** Status label when transfer is paused */
    paused: 'Paused',
  },
  { select }
);

export const QueuedJobStatus = ({ job }: { job: TransferBatch }) => {
  const isPaused = job.isPaused ?? false;
  const progressType = getProgressType(job);
  const bytesTotal = job?.progress?.bytesTotal || 0;
  const showBytesTotalSize = bytesTotal > 0;

  return (
    <ScrollingJob>
      {progressType === 'DOWNLOAD' ? (
        <IconArrowDown
          className={ARROW_ICON_CLASSNAME}
          color={theme.colors.icon.secondary}
          size={16}
        />
      ) : (
        <IconArrowUp
          className={ARROW_ICON_CLASSNAME}
          color={theme.colors.icon.secondary}
          size={16}
        />
      )}
      <>
        <Text color={isPaused ? 'body' : 'tertiary'} variant="secondary">
          {isPaused ? TEXT.paused : TEXT.queuedStatus(progressType)}
        </Text>
        {showBytesTotalSize && (
          <>
            <DotSeparator />
            <JobSize bytesTotal={bytesTotal} />
          </>
        )}
      </>
    </ScrollingJob>
  );
};
